import "jquery-validation";
import "jquery-validation-unobtrusive";

// NOTE: from here: https://github.com/brecons/jquery-validation-unobtrusive-bootstrap, but we need to customize for Select2, so not getting from npm
(function ($: any) {
    if ($.validator && $.validator.unobtrusive) {
        var defaultOptions = {
            validClass: 'is-valid',
            errorClass: 'is-invalid',
            ignore: ":hidden,.ignore",
            highlight: (element: Element, errorClass: string, validClass: string) => {
                $(element)
                    .removeClass(validClass)
                    .addClass(errorClass);
            },
            unhighlight: (element: Element, errorClass: string, validClass: string) => {
                $(element)
                    .removeClass(errorClass)
                    .addClass(validClass);
            }
        };

        $.validator.setDefaults(defaultOptions);

        $.validator.unobtrusive.options = {
            errorClass: defaultOptions.errorClass,
            validClass: defaultOptions.validClass,
            errorElement: 'div',
            errorPlacement: (error: any, element: any) => {
                error.addClass('invalid-feedback');

                // NOTE (LJ): adding the select2 bit ourselves
                if (element.next().is(".input-group-append") || element.next().is(".select2-container")) {
                    error.insertAfter(element.next());
                } else {
                    error.insertAfter(element);
                }
            }
        };
    }
    else {
        console.warn('$.validator is not defined. Please load this library **after** loading jquery.validate.js and jquery.validate.unobtrusive.js');
    }
})(jQuery);

// NOTE: source https://stackoverflow.com/questions/26122171/how-to-add-boolean-required-attribute-in-mvc (used on registration form where we demand they tick a box)
// extend jquery range validator to work for required checkboxes
var defaultRangeValidator = ($ as any).validator.methods.range;
($ as any).validator.methods.range = function (value: any, element: any, param: any) {
    if (element.type === 'checkbox') {
        // if it's a checkbox return true if it is checked
        return element.checked;
    } else {
        // otherwise run the default validation function
        return defaultRangeValidator.call(this, value, element, param);
    }
}